import BaseAPI from "../api";

const path = "notification";

export type MenuBadgeCount = { count: number };

/** เจ้าหน้าที่ (roleId ≠ 4) — backend นับด้วย COUNT ใน DB ไม่มีเพดาน */
export type AdminMenuBadge = {
  role: "ADMIN";
  /** จำนวนผู้ถือสิทธิที่มีผู้รับมรดกหมดอายุอย่างน้อย 1 คน (ไม่กรองสาขา) */
  customer_heir: MenuBadgeCount;
  bidder_preliminary: MenuBadgeCount;
  repair: MenuBadgeCount;
  cancel_contract: MenuBadgeCount;
  transfer: MenuBadgeCount;
  /** status = PROGRESS */
  invoice: MenuBadgeCount;
  certificate: MenuBadgeCount;
};

/** ผู้เช่า (roleId = 4) — backend ใช้ userId จาก token เท่านั้น */
export type TenantMenuBadge = {
  role: "TENANT";
  deposit: MenuBadgeCount;
  /** status IN (WAITING, NOT_PAY) รวมสัญญาที่รับโอนมา */
  invoice: MenuBadgeCount;
  /** เลือกชุดเมนู "ยังไม่มีสัญญา" / "มีสัญญาแล้ว" */
  has_lease_agreement: boolean;
};

/**
 * GET /notification/menu-badge?branchId= — ใช้ role แยกชนิด
 * LegacyMenuBadge คือ backend รุ่นก่อนที่ยังไม่มี role (มีแค่ customer_heir) ลบได้เมื่อ backend ใหม่ขึ้นทุก environment แล้ว
 */
export type LegacyMenuBadge = { role?: undefined; customer_heir?: MenuBadgeCount };
export type MenuBadgeResponse = AdminMenuBadge | TenantMenuBadge | LegacyMenuBadge;

/** 1 แถว = สิทธิผู้รับมรดกของ user ที่ login ที่หมดอายุแล้ว (รับมรดกให้ผู้ถือสิทธิคนนี้) */
export type HeirExpiredAlertItem = {
  id_customer_agent: number;
  /** customerId ของผู้ถือสิทธิ */
  customerId_owner: number;
  /** ชื่อ-นามสกุลผู้ถือสิทธิ */
  owner_fullname: string;
  /** วันที่เริ่มหมดอายุ YYYY-MM-DD */
  heir_expire_date: string;
};

/**
 * GET /notification/alert — มองจากฝั่งผู้รับมรดก: user ที่ login เป็นผู้รับมรดกให้ใครแล้วหมดอายุ
 * backend อ่าน customerId จาก JWT เอง count = 0 คือไม่ต้องแจ้ง
 */
export type NotificationAlertResponse = {
  customer_heir?: { count: number; items: HeirExpiredAlertItem[] };
};

/**
 * backend ชุดใหม่ห่อ payload ไว้ใน { success, status, message, data } (แบบเดียวกับ customer-agent / inheritance-transfer)
 * แต่ตัวอย่างใน api doc แสดงเฉพาะก้อนใน data — แกะให้ที่นี่ที่เดียว รองรับทั้งแบบห่อและไม่ห่อ
 * payload ของเส้นนี้ไม่มี key ชื่อ data จึงแยกสองแบบออกจากกันได้
 */
const unwrapPayload = <T>(body: any): T =>
  (body && typeof body === "object" && "data" in body ? body.data : body) || ({} as T);

export default class NotificationApi extends BaseAPI {
  /** คืน payload ที่แกะ envelope แล้ว (ไม่ใช่ AxiosResponse) */
  static menuBadge(branchId: number): Promise<MenuBadgeResponse> {
    return this.api.get(`${path}/menu-badge`, { params: { branchId } }).then((res) => unwrapPayload<MenuBadgeResponse>(res.data));
  }
  /** คืน payload ที่แกะ envelope แล้ว (ไม่ใช่ AxiosResponse) */
  static alert(): Promise<NotificationAlertResponse> {
    return this.api.get(`${path}/alert`).then((res) => unwrapPayload<NotificationAlertResponse>(res.data));
  }
}
